import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { Offer } from '../../models/offer.model';
import { PagedResult } from '../../models/pagedResult.model';

@Injectable({
  providedIn: 'root'
})
export class OfferService {

  constructor(private http: HttpClient, private apiService: ApiService) { }

  apiUrl = `${this.apiService.apiUrl}/offers`;

  getAllOffers(): Observable<{ id: string, name: string }[]>{
    return this.http.get<{ id: string, name: string }[]>(this.apiUrl + '/all');
  }
  getAllOffersCodes(): Observable<string[]>{
    return this.http.get<string[]>(this.apiUrl + '/allcodes');
  }
  getOffers(pageIndex: number, pageSize: number, sortField: string, sortOrder: string, search: string): Observable<PagedResult<Offer>> {
    let params = new HttpParams()
      .set('pageIndex', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('sortField', sortField)
      .set('sortOrder', sortOrder)
      .set('search', search);

    return this.http.get<PagedResult<Offer>>(this.apiUrl, { params });
  }

  getOfferPages(offerId: string): Observable<Offer> {
    return this.http.get<Offer>(`${this.apiUrl}/${offerId}`);
  }

  deleteOffer(offerId: string): Observable<Offer> {
    return this.http.delete<Offer>(`${this.apiUrl}/${offerId}`);
  }
  createOffer(offerData: Offer): Observable<Offer> {
    return this.http.post<Offer>(`${this.apiUrl}`, offerData);
  }

  updateOffer(offerData: Offer, offerId: string): Observable<Offer> {
    return this.http.patch<Offer>(`${this.apiUrl}/${offerId}`, offerData);
  }
  associateOfferPage(offerId: string, pageId: string): Observable<boolean> {
    const payload = {
      pageId: pageId
    };
    return this.http.patch<boolean>(`${this.apiUrl}/${offerId}/associatepage`, payload);
  }
  disassociateOfferPage(offerId: string, pageId: string): Observable<boolean> {
    const payload = {
      pageId: pageId
    };
    return this.http.patch<boolean>(`${this.apiUrl}/${offerId}/disassociatepage`, payload);
  }
}
